import { Col, InputField, Label, ModalPopup, Row, ReactSelectBox } from "client/CommonComponents";
import { MaskedTextField } from "@fluentui/react"
import './DealerDetails.scss'
import { isNumber } from "utils";
import DealerVendorListContent from "../RequisitionType/DealerVendorListContent";

const DealerDetails = (props: any) =>{
    const reason = props?.reason;
    const handleQuotePriceChange = props?.handleQuotePriceChange;
    const handleContactChange = props?.handleContactChange;
    const handlePhoneChange = props?.handlePhoneChange;
    const handleEmailChange = props?.handleEmailChange;
    const handleAddressLine1Change = props?.handleAddressLine1Change;
    const handleAddressLine2Change = props?.handleAddressLine2Change;
    const handleAddressLine3Change = props?.handleAddressLine3Change;
    const handleCityChange = props?.handleCityChange;
    const handleStateChange = props?.handleStateChange;
    const handleZipCodeChange= props?.handleZipCodeChange;
    const quotePriceFormat = props?.quotePriceFormat;
    const vendorDropdownList = props?.vendorDropdownList;
    const onChangeVendorName = props?.onChangeVendorName;
    const filterOptionVendor = props.filterOptionVendor;
    const vendor = props.vendor;
    const dealerVendorPopupClick = props.dealerVendorPopupClick;
    const showDealerVendorPopup = props.showDealerVendorPopup;
    const setShowDealerVendorPopup = props.setShowDealerVendorPopup;
    const dealerSelectOnBlur = props.dealerSelectOnBlur;
    const vendorSearchText = props.vendorSearchText;
    const OnBlurOfFields = props?.OnBlurOfFields;

    return(
        <Row>
            { reason?.showQuotePrice ? 
            <>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-2 mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_13">Quote Price</Label>
                <InputField  
                className={reason.quotePriceError ? 'controlValidation' : ''}
                onChange={(item: any, e: any) => handleQuotePriceChange(e, item, reason)}
                name = "quotePrice"
                placeholder="0.00"
                onBlur={(event: any) => quotePriceFormat(event,reason)}
                prefix={"$"}
                onKeyPress={(event: any) => { isNumber(event) }}
                value = {reason?.quotePrice} data-attribute="DealerDetails_quotePrice_Input_2" />
                {reason?.quotePriceError ? <p className='validMessage'>{reason?.quotePriceError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-2 mb-3'>
                <Label data-attribute="DealerDetails_Default_Label_2_2">Estimated Price (incl. tax & fees)</Label>
                <InputField 
                name = "estimatedPrice"
                placeholder="0.00"
                prefix={"$"}
                disabled = {true}
                value = {reason?.estimatedPrice} data-attribute="DealerDetails_estimatedPrice_Input_2" />
            </Col>
            </>
            : null}
            <p className='vendorHeading'>Dealer Details</p>
            <Row className="mx-0 px-0">
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <div className="dealer-name"><Label required data-attribute="DealerDetails_Default_Label_3_2">Dealer Name </Label><a href='/' className='dealer-list' onClick={dealerVendorPopupClick}>Dealer/Vendor not listed?</a></div>
                <ReactSelectBox
                    options={vendorDropdownList}
                    onChange={(item: any) => onChangeVendorName(item, reason)}
                    value={vendor || ""}
                    name={vendor?.value}
                    isSearchable={true}
                    inputValue={vendorSearchText}
                    onInputChange={(value: any, action: any) => filterOptionVendor(value, action)}
                    className={reason?.nameError ? 'controlValidation' : ''}
                    onBlur={dealerSelectOnBlur}
                    isDisabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_Default_SearchSelectBox" />
                {reason?.nameError ? <p className='validMessage'>{reason?.nameError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_4_2">Dealer Contact</Label>
                <InputField 
                className={reason.contactError ? 'controlValidation' : ''}
                placeholder='Enter Contact'
                onChange={(item: any, e: any) => handleContactChange(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "Contact"
                value = {reason?.contact}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_Contact_Input" />
                {reason?.contactError ? <p className='validMessage'>{reason?.contactError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_5_2">Dealer Phone</Label>
                <MaskedTextField 
                className={reason.phoneError ? 'controlValidation form-input' : 'form-input'}
                mask="999-999-9999" 
                placeholder='Enter Phone'
                onChange={(item: any, e: any) => handlePhoneChange(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "Phone"
                value = {reason?.phone}
                disabled = {reason?.isDisabled}
                />
                {reason?.phoneError ? <p className='validMessage'>{reason?.phoneError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_6_2">Email Address</Label>
                <InputField 
                className={reason.emailError ? 'controlValidation' : ''}
                placeholder='Enter Email'
                onChange={(item: any, e: any) => handleEmailChange(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "Email"
                value={reason?.email}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_Email_Input" />
                {reason?.emailError ? <p className='validMessage'>{reason?.emailError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_7_2">Address Line 1</Label>
                <InputField 
                className={reason.addressLine1Error ? 'controlValidation' : ''}
                placeholder='Enter Address Line 1'
                onChange={(item: any, e: any) => handleAddressLine1Change(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "AddressLine1"
                value = {reason?.addressLine1}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_AddressLine1_Input" />
                {reason?.addressLine1Error ? <p className='validMessage'>{reason?.addressLine1Error}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label data-attribute="DealerDetails_Default_Label_8_2">Address Line 2</Label>
                <InputField 
                className={reason.addressLine2Error ? 'controlValidation' : ''}
                placeholder='Enter Address Line 2'
                onChange={(item: any, e: any) => handleAddressLine2Change(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "AddressLine2"
                value = {reason?.addressLine2}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_AddressLine2_Input" />
                {reason?.addressLine2Error ? <p className='validMessage'>{reason?.addressLine2Error}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label data-attribute="DealerDetails_Default_Label_9_2">Address Line 3</Label>
                <InputField 
                className={reason.addressLine3Error ? 'controlValidation' : ''}
                placeholder='Enter Address Line 3'
                onChange={(item: any, e: any) => handleAddressLine3Change(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "AddressLine3"
                value = {reason?.addressLine3}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_AddressLine3_Input" />
                {reason?.addressLine3Error ? <p className='validMessage'>{reason?.addressLine3Error}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_10_2">City</Label>
                <InputField
                className={reason.cityError ? 'controlValidation' : ''} 
                placeholder='Enter City'
                onChange={(item: any, e: any) => handleCityChange(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "City"
                value = {reason?.city}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_City_Input" />
                {reason?.cityError ? <p className='validMessage'>{reason?.cityError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_11_2">State</Label>
                <InputField 
                className={reason.stateError ? 'controlValidation' : ''}
                placeholder='Enter State Code'
                onChange={(item: any, e: any) => handleStateChange(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "State"
                value = {reason?.state}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_State_Input" />
                {reason?.stateError ? <p className='validMessage'>{reason?.stateError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-3 mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label_12_2">Zip Code</Label>
                <InputField
                className={reason.zipCodeError ? 'controlValidation' : ''}
                placeholder='Enter Zip Code'
                onChange={(item: any, e: any) => handleZipCodeChange(e, item, reason)}
                onBlur={() => OnBlurOfFields(reason)}
                name = "ZipCode"
                onKeyPress={(event: any) => { isNumber(event) }}
                value = {reason?.zipCode}
                disabled = {reason?.isDisabled}
                 data-attribute="DealerDetails_ZipCode_Input" />
                {reason?.zipCodeError ? <p className='validMessage'>{reason?.zipCodeError}</p> : null}
            </Col>
            </Row>
            {
            showDealerVendorPopup && 
            <ModalPopup
                ShowModalPopupFooter={false}
                ModalPopupTitle="Dealer/Vendor not listed?"
                ModalPopupType="medium"
                closeModalPopup={() => setShowDealerVendorPopup(false)}
                ModalPopupName='Dealer-Vendor-Popup'
             data-attribute="DealerDetails_Default_ModalPopup_2">
                <DealerVendorListContent/>
            </ModalPopup>
            }
        </Row>
    )
}
export default DealerDetails;